export default function CreatePoButton({ onClick, label = "CREATE PO", disabled = false }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="px-4 py-1.5 bg-blue-600 rounded-md shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] inline-flex justify-start items-center gap-2 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
    >
      <svg
        className="w-3 h-3.5 text-white"
        viewBox="0 0 12 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path d="M6 1.31v11.38M0.44 7h11.12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
      <span className="text-center justify-center text-white text-sm font-InterSemiBold leading-5 tracking-tight">
        {label}
      </span>
    </button>
  );
}
